import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../JourneysList.css';

const API_URL = 'http://localhost:5000';

function JourneysList({ token, onBack, onSelectJourney, userRole }) {
  const [journeys, setJourneys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchJourneys();
  }, []);

  const fetchJourneys = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await axios.get(
        `${API_URL}/api/journey-configs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setJourneys(response.data.configs);
    } catch (err) {
      setError('Failed to load journeys. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    return `status-badge status-${status}`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div className="journeys-list-container">
      <div className="list-header">
        <h2>All Innovation Journeys</h2>
        {userRole === 'admin' && (
          <button className="back-btn" onClick={onBack}>
            ← Create New Journey
          </button>
        )}
      </div>

      {loading && <div className="loading">Loading journeys...</div>}

      {error && <div className="error-message">{error}</div>}

      {!loading && journeys.length === 0 && (
        <div className="empty-state">
          {userRole === 'admin' ? (
            <>
              <p>No journeys created yet.</p>
              <button className="create-btn" onClick={onBack}>Create the first journey</button>
            </>
          ) : (
            <p>No journeys assigned yet. Contact an administrator to be added to a journey.</p>
          )}
        </div>
      )}

      {!loading && journeys.length > 0 && (
        <div className="journeys-grid">
          {journeys.map(journey => (
            <div
              key={journey.id}
              className="journey-card"
              onClick={() => onSelectJourney(journey.id, journey)}
            >
              <div className="card-header">
                <h3>{journey.title}</h3>
                <span className={getStatusBadgeClass(journey.status)}>
                  {journey.status}
                </span>
              </div>

              {journey.description && (
                <p className="card-description">{journey.description}</p>
              )}

              <div className="card-details">
                <div className="detail-item">
                  <span className="label">Facilitator:</span>
                  <span className="value">{journey.facilitator_id}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Team Members:</span>
                  <span className="value">
                    {journey.team_member_ids ? journey.team_member_ids.length : 0}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="label">Max Participants:</span>
                  <span className="value">{journey.max_participants}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Duration:</span>
                  <span className="value">{journey.duration_days} days</span>
                </div>
                <div className="detail-item">
                  <span className="label">Created:</span>
                  <span className="value">{formatDate(journey.created_at)}</span>
                </div>
              </div>

              <div className="card-footer">
                <button className="view-btn">
                  View Journey →
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default JourneysList;
